import script from "./WritingView.vue?vue&type=script&setup=true&lang=js"
export * from "./WritingView.vue?vue&type=script&setup=true&lang=js"

import "./WritingView.vue?vue&type=style&index=0&id=d3b86116&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3b86116"]])

export default __exports__